import { __awaiter, __generator, __read } from "tslib";
import React, { useEffect, useState } from "react";
import { LoadingTip, ErrorTip } from "../tips";
export function CascaderLoading(_a) {
    var onLoad = _a.onLoad;
    var _b = __read(useState(false), 2), error = _b[0], setError = _b[1];
    useEffect(function () {
        handleLoad();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    function handleLoad() {
        return __awaiter(this, void 0, void 0, function () {
            var _1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setError(false);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, onLoad()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _1 = _a.sent();
                        setError(true);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    if (error) {
        return React.createElement(ErrorTip, { onRetry: handleLoad });
    }
    return React.createElement(LoadingTip, null);
}
CascaderLoading.displayName = "CascaderLoading";
//# sourceMappingURL=CascaderLoading.js.map